var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 75,
    viewBox: "0 0 70 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-darker"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.2561 22.7574C65.8914 16.4596 65.3083 4.99638 57.3359 3.46211C50.5122 2.15432 43.6337 8.53982 40.8262 14.0778C38.1085 19.4405 36.0515 25.1977 34.5111 31.0791C32.419 26.6954 29.8701 22.5967 25.5302 20.1126C19.3223 16.5619 11.9343 18.4542 7.05322 23.4223C1.91711 28.6608 2.68929 36.9239 5.48322 43.1195C8.61804 50.0691 14.5867 54.5075 21.1229 58.0246C28.3933 61.9363 36.3233 65.0224 41.8032 71.4685C42.873 72.7266 48.5406 68.7741 47.8589 67.9733C47.5702 67.6328 47.2713 67.3041 46.9681 66.9804C48.0094 66.4354 49.2261 65.6456 49.5746 64.6483C52.1323 57.3364 56.8909 51.2154 60.7061 44.5559C64.6389 37.6911 66.7179 30.7357 66.2561 22.7574M54.7892 47.1174C51.3832 52.9958 47.3225 58.5003 44.6085 64.7302C33.982 55.6129 17.8009 53.5058 11.539 39.6272C9.85482 35.8865 8.90573 31.6562 9.60425 27.5648C9.84255 26.1767 10.4757 23.0132 11.7574 22.2168C13.0824 21.3912 15.8507 22.2241 17.1894 22.6698C25.9029 25.5922 28.5752 35.3532 32.1581 42.7871C32.7661 44.0481 38.0574 40.6793 38.232 39.5688C39.6745 30.3923 42.2007 21.267 46.1138 12.8139C46.944 11.0166 48.3236 7.45853 50.5268 7.18821C52.5948 6.9325 54.7059 8.39367 55.9709 9.84758C58.7141 13.0111 59.2307 17.5847 59.7503 21.5666C60.9626 30.8672 59.4857 39.0135 54.7892 47.1174V47.1174Z",
    stroke: "#67FC17",
    strokeOpacity: 0.7,
    strokeWidth: 6.5767,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHeart);
export default __webpack_public_path__ + "static/media/green-heart.6cff3fb33f7d2f2ad7b64b4e18a9aed5.svg";
export { ForwardRef as ReactComponent };